import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Skeleton } from '@material-ui/lab'
import { isNil } from 'lodash'

import { LocationLogo } from './Location'

const useStyles = makeStyles(theme => ({
  restaurantName: {
    fontSize: '40px',
    marginLeft: theme.spacing(4),
  },
  restaurantNameSkeleton: {
    marginLeft: theme.spacing(4),
  },
}))

const RestaurantDetails = ({ logoLink, name, loading }) => {
  const classes = useStyles()

  if (isNil(name) || loading) return <SkeletonLoading />

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <LocationLogo logoAlt={name} logoLink={logoLink} />
      <Typography component="h2" variant="h6" className={classes.restaurantName}>
        {name}
      </Typography>
    </Box>
  )
}

const SkeletonLoading = () => {
  const classes = useStyles()
  return (
    <Box alignItems="center" display="flex" marginBottom={3}>
      <Skeleton height={150} width={150} />
      <Skeleton height={50} width={300} className={classes.restaurantName} />
    </Box>
  )
}

export default RestaurantDetails
